const CreditsText = () => {
    return (
        <>Hecho con ♥ por Five Digital Minds - 2026 | v5.6.1</>
    )
}

export { CreditsText };